import styled from "@emotion/styled";
import { FC, memo } from "react";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { NAVIGATION_ITEMS } from "constants/navigation-items";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { NavigationItemInterface, NavigationItems } from "interfaces/navigationItem";
import { IAgent } from "store/entities/agents";
import { withVar } from "themes/helpers";

import { NavigationItem } from "./NavigationItem";
import { INavigationProps as IProps } from "./interfaces";

const items: NavigationItemInterface[] = NAVIGATION_ITEMS.filter(item =>
  item?.breakpoints?.includes(ResponsiveBreakpointType.Mobile)
).sort((a, b) => (a.id === NavigationItems.Settings && b.id === NavigationItems.Subscription ? -1 : 0)); // Settings in the center. This isn't the case in the desktop nav

function canAccessItem(item: NavigationItemInterface, canAccessApp: boolean, agent: IAgent): boolean {
  return Boolean(
    (canAccessApp || item.activeWhenAppAccessNotAllowed) &&
      (!item.permissions || item.permissions.includes(agent.permission))
  );
}

const NavigationComponent: FC<IProps> = memo(({ canAccessApp, agent }) => (
  <Wrapper>
    <Content>
      {items.map(item => (
        <NavigationItem key={item.id} item={item} isMobile accessAllowed={canAccessItem(item, canAccessApp, agent)} />
      ))}
    </Content>
  </Wrapper>
));

NavigationComponent.displayName = "NavigationComponent";

const Wrapper = styled.div`
  display: flex;
  background-color: ${withVar(DesignToken.NavbarBackground)};

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    padding: ${withVar(SpacingToken.Spacing2)} 0;
  }
`;

const Content = styled.nav`
  flex: 1;
  display: flex;
  justify-content: space-around;
`;

export default NavigationComponent;
